import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DeviceModel {
  assetModelId: string
  assetModel: string
  assetTypeId: string
}

export interface DeviceModelState {
  isLoading: boolean
  loadingError: string | null
  deviceModel: DeviceModel[] | null
  httpStatus: number | null
}

export const initialState: DeviceModelState = {
  isLoading: true,
  loadingError: null,
  deviceModel: null,
  httpStatus: null
}

const deviceModelSlice = createSlice({
  name: 'deviceManagementDeviceModel',
  initialState,
  reducers: {
    deviceModelLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        deviceModel: null,
        httpStatus: 0
      }
    },
    deviceModelUpdateAction: (state, action: PayloadAction<{ data: DeviceModel[], httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        deviceModel: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    deviceModelErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        deviceModel: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  deviceModelLoadingAction,
  deviceModelUpdateAction,
  deviceModelErrorAction
} = deviceModelSlice.actions

export default deviceModelSlice.reducer
